// extracted by mini-css-extract-plugin
export default {"div":"Privacy_div__yW2IO"};